import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Interface } from '@leverege/api-redux'
import { Flex, Button, Toast } from '@leverege/ui-elements'
import { Icons, ParentRelationshipCreator } from '@leverege/api-attributes'
import Pagination from 'react-js-pagination'
import classnames from 'classnames'
import moment from 'moment'
import { List, Loading, TextInput } from '../views'
import RelationshipItem from './RelationshipItem'
import style from './style.css'
import ValueCard from '../views/ValueCard'

class ParentRelationshipViewer extends React.Component {

  static TYPE = ParentRelationshipCreator.typeName()

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
  }

  static isOneTo( att ) {
    return att?.relationshipType?.startsWith( 'oneTo' )
  }

  constructor( props ) {
    super( props )

    this.state = {
      showAddModal : false,
      search : null,
      pagination : {
        startIndex : 0,
        perPage : 100
      }
    }

    this.reload()
    
  }

  reload = async () => {
    const { dispatch, actions, attribute } = this.props
    const { pagination, search } = this.state

    if ( !ParentRelationshipViewer.isOneTo( attribute ) ) {
      dispatch( actions.list( { ...pagination, search } ) )
    }
  }

  onClick = () => {
    this.setState( { showAddModal : true } )
  }

  onEvent = ( type, item ) => {
    const { history } = this.props
    if ( type === RelationshipItem.GO_TO_ITEM ) {
      history.push( `/project/${item.projectId}/system/${item.systemId}/device/${item.id}/sim` )
    } else if ( type === RelationshipItem.GO_TO_ITEM_DETAILS ) {
      history.push(
        `/project/${item.projectId}/system/${item.systemId}/device?search=${item.id}&start=0&selected=${item.id}`
      )
    }
  }

  onGoTo = () => {
    const { interfaceVal, history, attribute, value, device } = this.props
    if ( ParentRelationshipViewer.isOneTo( attribute ) ) {
      if ( value?.id != null ) {
        history.push( `/project/${device.projectId}/system/${device.systemId}/device/${value.id}/sim` )
      }
    }
    const item = interfaceVal?.id ? interfaceVal : null
    if ( item != null ) {
      history.push( `/project/${item.projectId}/system/${item.systemId}/device/${item.id}/sim` )
    }
  }

  onGoToDetails = () => {
    const { interfaceVal, history } = this.props
    const item = interfaceVal?.id ? interfaceVal : null
    if ( item != null ) {
      history.push(
        `/project/${item.projectId}/system/${item.systemId}/device?search=${item.id}&start=0&selected=${item.id}`
      )
    }
  }

  onPageChange = ( pageNumber ) => {
    this.setState( ( state ) => {
      const startIndex = state.pagination.perPage * ( pageNumber - 1 )
      return { pagination : { ...state.pagination, startIndex } }
    } )
  }

  componentDidUpdate( prevProps, prevState ) {
    const { pagination : { startIndex : newStartIndex, perPage : newPerPage }, search : newSearch } = this.state
    const { pagination : { startIndex : oldStartIndex, perPage : oldPerPage }, search : oldSearch } = prevState

    if ( oldStartIndex !== newStartIndex || oldPerPage !== newPerPage || oldSearch !== newSearch ) {
      this.reload()
    }
  }

  onSearchChange = ( search ) => {
    this.setState( { search } )
  }

  onCopy = ( { data } ) => {
    navigator.clipboard
      .writeText( data )
      .then( () => {
        Toast.success( 'Copied to clipboard' )
      } )
      .catch( ( err ) => {
        Toast.error( [ 'Error copying to clipboard', err.message ] )
      } )
  }

  render() {
    const { attribute : attr, interfaceVal, isLoading } = this.props
    const { pagination, search } = this.state
    if ( attr == null ) {
      return <div />
    }
    if ( ParentRelationshipViewer.isOneTo( attr ) ) {
      const { attribute : attr, name, show, value, onClick } = this.props
      if ( attr == null ) {
        return <div />
      }
      // const safeValue = ( typeof value === 'object' && value != null ) ? JSON.stringify( value, null, 2 ) : value
    
      const icon = Icons.getIcon( attr )

      return (
        <ValueCard
          valid
          editable={false}
          name={name || attr.name}
          value={(
            <Flex variant="colSStart">
              <Flex variant="rowS">
                <Button
                  variant="linkTable"
                  onClick={this.onGoTo}>{value?.id || '---'}
                </Button>
                <Button
                  variant="secondaryIconic"
                  icon="fa fa-copy"
                  onClick={this.onCopy}
                  eventData={value?.id || '==='} />
              </Flex>
              <span>{( value?.time && moment( value.time ).format( 'L LTS' ) ) || '---'}</span>
            </Flex>
          )}
          icon={icon}
          onClick={onClick} />
      )
  
    }

    const { perPage, startIndex } = pagination
    const { attribute, sourceBlueprint } = this.props
    const list = interfaceVal( pagination )
    const toView = list?.items.map( x => x[sourceBlueprint?.alias || sourceBlueprint?.id] )

    let total = 0
    if ( list ) {
      total = list.total
    }

    return (
      <div className={style.left}>
        <div className={style.header}>
          <div className={style.name}>
            {`${attr?.name} Parents`}
          </div>
          <div className={style.controls}>
            <Flex variant="rowM" className={style.searchContainer}>
              <Button icon="fa fa-fw fa-refresh" variant="secondary" onClick={this.reload} />
              <TextInput
                className={style.searchBar}
                value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.onSearchChange} />
              <i className={classnames( 'fa fa-search', style.searchIcon )} />
            </Flex>
          </div>
        </div>
        <List className={style.list}
          onEvent={this.onEvent} 
          noItemsView={<div className={style.list} />}
          items={toView}
          itemView={RelationshipItem}
          itemProps={{ showDelete : false }} />
        <Pagination
          innerClass={classnames( 'pagination', style.pagination )}
          activePage={( startIndex / perPage ) + 1}
          itemsCountPerPage={perPage}
          totalItemsCount={total}
          pageRangeDisplayed={5}
          onChange={this.onPageChange} />
        <Loading show={isLoading} message="Loading..." />
       
      </div>
    )
  }
}

export default withRouter( connect(
  ( state, props ) => {
    const { device, attribute } = props
    let actions = null
    if ( device && attribute ) {
      if ( !ParentRelationshipViewer.isOneTo( attribute ) ) {
        actions = Interface.create( device?.systemId, attribute?.sourceBlueprintId )
          .obj( '*' )
          .grp( attribute.parentPath )
          .obj( device.id )
      }
    }

    return {
      interfaceVal : ParentRelationshipViewer.isOneTo( attribute ) ?
        null :
        pagination => actions?.getTable( state, pagination ),
      actions,
      isLoading : actions?.isLoading( state ),
      sourceBlueprint : state.blueprints.index[attribute?.sourceBlueprintId]
    }
  }
)( ParentRelationshipViewer ) )
